
import { motion } from 'framer-motion';

const PageTransition = (WrappedComponent) => {
  return (props) => (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <WrappedComponent {...props} />
    </motion.div>
  );
};

export default PageTransition;
